var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 54,
    viewBox: "0 0 51 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7255 22.0002H7.2729C5.88591 21.9888 4.55116 22.5288 3.5623 23.5014C2.57342 24.474 2.01143 25.7995 2 27.1864V46.8148C2.02566 49.7019 4.38594 52.022 7.2729 51.9977H16.7255C18.1123 52.0094 19.4472 51.4694 20.4361 50.4968C21.4251 49.5242 21.987 48.1987 21.9984 46.8115V27.1864C21.987 25.7995 21.4251 24.474 20.4361 23.5014C19.4472 22.5288 18.1123 21.9888 16.7255 22.0002Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7255 2.00201H7.2729C4.444 1.92355 2.08529 4.14957 2 6.97827V10.358C2.08529 13.1867 4.444 15.4127 7.2729 15.3342H16.7255C19.5542 15.4127 21.913 13.1867 21.9984 10.358V6.97827C21.913 4.14957 19.5542 1.92355 16.7255 2.00201Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9374 31.9998H43.3867C44.7742 32.0121 46.1098 31.4725 47.0994 30.4999C48.0889 29.527 48.6516 28.2011 48.6629 26.8136V7.18838C48.6516 5.80142 48.0896 4.4758 47.1007 3.50318C46.1118 2.53056 44.7769 1.9906 43.39 2.00213H33.9374C32.5506 1.9906 31.2157 2.53056 30.2268 3.50318C29.2378 4.4758 28.6759 5.80142 28.6646 7.18838V26.8136C28.6759 28.2004 29.2378 29.526 30.2268 30.4986C31.2157 31.4712 32.5506 32.0111 33.9374 31.9998Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9374 51.9983H43.3867C46.2168 52.0786 48.5776 49.8522 48.6629 47.0221V43.6423C48.5776 40.8136 46.2188 38.5877 43.39 38.6661H33.9374C31.1087 38.5877 28.7499 40.8136 28.6646 43.6423V47.0187C28.7479 49.8488 31.1073 52.0766 33.9374 51.9983Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.69178e236bb0e7674031a22aedcd6fe6.svg";
export { ForwardRef as ReactComponent };